__turbopack_context__.v({
  "placeholder": "Placeholder-module-scss-module__3VjOKG__placeholder",
});
